import React, { useState, useRef } from 'react'
import DataGridAlternativa from '../../../../components/DataGridAlternativa'
import { excluir, } from '../../../../util/AcessoApi'
import { Visualizar, Excluir, BtnAcao } from '../../../../components/Acoes'
import { mensagens } from '../../../../util/Utilitarios.js'
import { mostrarToast } from '../../../../components/Toasts'
import { validarAcessoPreAnestesico } from '../../../../util/FuncoesComuns'

const Consulta = props => {
    const [data, setData] = useState([])
    const target = useRef(null)

    const columns = React.useMemo(
        () => [{
            id: 'consulta-pre-anestesico',
            columns: [
                {
                    Header: 'Código',
                    accessor: 'id',
                    html: item => <span>{item.id}<div className='circulo-consulta' style={item.liberado == "SIM" ? { background: 'rgb(0, 173, 98)' } : { background: 'rgb(173, 0, 0)' }}></div></span>,
                    ordenamento: {
                        tipo: 'numero',
                        ativo: true,
                        modo: 'desc',
                    }
                },
                {
                    Header: 'Identificação',
                    accessor: 'cpf',
                    visivel: true,
                    ordenamento: {
                        tipo: 'texto'
                    }
                },
                {
                    Header: 'Paciente',
                    accessor: 'beneficiario',
                    visivel: true,
                    ordenamento: {
                        tipo: 'texto'
                    },
                    filtro: {
                        tipo: 'beneficiario',
                        idColuna: 'beneficiario_id'
                    }
                },
                {
                    Header: 'Operadora Saúde',
                    accessor: 'operadora_saude',
                    visivel: true,
                    ordenamento: {
                        tipo: 'texto'
                    },
                    filtro: {
                        tipo: 'operadora_saude',
                        idColuna: 'questionario_paciente.operadora_saude_id'
                    }
                },
                {
                    Header: 'Estabelecimento Saúde',
                    accessor: 'estabelecimento_saude',
                    visivel: true,
                    ordenamento: {
                        tipo: 'texto'
                    },
                    filtro: {
                        tipo: 'estabelecimento_saude',
                        idColuna: 'questionario_paciente.estabelecimento_saude_id'
                    }
                },

                {
                    Header: 'Sócio',
                    accessor: 'socio',
                    visivel: true,
                    ordenamento: {
                        tipo: 'texto'
                    },
                    filtro: {
                        tipo: 'socio',
                        idColuna: 'socio_id'
                    }
                },
                {
                    Header: 'Liberado P/ Cirurgia?',
                    accessor: 'liberado',
                    visivel: true,
                    ordenamento: {
                        tipo: 'texto'
                    }
                },
                {
                    Header: 'Data Hora Liberação',
                    accessor: 'data_registro',
                    ordenamento: {
                        tipo: 'data'
                    }
                }
            ]
        }], []
    )


    const alteracao = async (propsAcao) => {
        validarAcessoPreAnestesico(() => {
            window.open('/preanestesico/consultapreanestesico/alteracao/' + propsAcao.row.id, '_blank');
  
        }, () => {
            mostrarToast('erro', "A ação não é permitida: O usuário logado não está associado ao sócio que efetuou a consulta");

        }, propsAcao.row.id)
    }

    const exclusao = async (propsAcao) => {

        excluir('/preanestesico/consultapreanestesico', propsAcao.row.id,
            () => {
                target.current.atualizar();
                mostrarToast('sucesso', mensagens['sucesso'])
            },
            (e) => {
                if (e.response && e.response.data && e.response.data.erros)
                    e.response.data.erros.forEach((item) => mostrarToast('erro', item))
                else
                    mostrarToast('erro', mensagens.erro)
            }, propsAcao.row.descricao_auditoria)
    }


    const acoesObj = [
        (propsAcao) => <Visualizar to={'/preanestesico/consultapreanestesico/visualizacao/' + propsAcao.id} />,
        (propsAcao) => <BtnAcao icone="icon-Pen" texto="Alterar" action={() => alteracao(propsAcao)} />,
        (propsAcao) => <Excluir to={'/preanestesico/consultapreanestesico/consulta/'} action={() => exclusao(propsAcao)} />,
    ]

    return (
        <>
            <div>
                <DataGridAlternativa acoesObj={acoesObj} removerTotalPaginas data={data} columns={columns} setData={setData} acoes={true} target={target} caminhoBase='/preanestesico/consultapreanestesico' caminhoConsultaFiltros='/preanestesico/consultapreanestesicoPaginacao' modulo={props.modulo} titulo={'Consulta Pré-Anestésica'}
                    tituloLista={'Lista Consulta Pré-Anestésica'} icone={'icon-Tablet'} preAnestesico={true} />
            </div>
        </>
    )
}

export default Consulta